import { render, staticRenderFns } from "./ContractDetails.vue?vue&type=template&id=7653274b&scoped=true&"
import script from "./ContractDetails.vue?vue&type=script&lang=js&"
export * from "./ContractDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContractDetails.vue?vue&type=style&index=0&id=7653274b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7653274b",
  null
  
)

export default component.exports